<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item >首页</el-breadcrumb-item>
          <el-breadcrumb-item>统计</el-breadcrumb-item>
          <el-breadcrumb-item>拼团任务</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">
          <el-form-item >
            <el-input  placeholder="项目名称" size="small" v-model="queryParam.name" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-input  placeholder="商家名称" size="small" v-model="queryParam.businessName" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-select v-model="queryParam.state" size="small" placeholder="请选择状态" clearable>
              <el-option label="请选择" value="="></el-option>
              <el-option label="进行中" value="0"></el-option>
              <el-option label="拼团成功" value="1"></el-option>
              <el-option label="拼团失败" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="Search" size="small">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="items" style="width: 100%">
          <el-table-column  prop="Title" :show-overflow-tooltip="true" fixed="left" label="项目"> </el-table-column>
          <el-table-column  prop="BusinessName" label="商家名称"> </el-table-column>
          <el-table-column  prop="MemberName" label="团长"> </el-table-column>
          <el-table-column  prop="NeedPeople" label="需要人数"> </el-table-column>
          <el-table-column  prop="ParticipateNumber" label="已参人数"> </el-table-column>
          <el-table-column  prop="CreateTime"  :show-overflow-tooltip="true" label="创建时间" > </el-table-column>
          <el-table-column  prop="DueTime"  :show-overflow-tooltip="true" label="到期时间" > </el-table-column>
          <el-table-column  prop="State"  label="状态"  > 
            <template slot-scope="scope">
              <span v-if="scope.row.State == 0">进行中</span>
              <span v-if="scope.row.State == 1">拼团成功</span>
              <span v-if="scope.row.State == 2">拼团失败</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam: {
          pageIndex: 1,
          pageSize: 10,
          sort: ' CreateTime desc ',
          totalCount:10,
          name:'',
          businessName:'',
          state:''
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/GroupBooking/Tuan',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.items
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val 
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px    

</style>